const Immutable = require('immutable');
const createSelector = require('./createSelector');
const programListSelector = require('./programListSelector');

const autoCompleteActiveIndexSelector	= (state) => state.getIn(['auto_complete', 'meta', 'index']);
const autoCompleteQuerySelector	= (state) => state.getIn(['auto_complete', 'meta', 'query'], '');
const AUTO_COMPLETE_MAX_ITEMS = 5;

const autoCompleteSuggestionsSelector = createSelector(
	[
		programListSelector,
		autoCompleteQuerySelector
	],
	(values, query, link) => {
		
		
		const escapedQuery = query.replace(/[\[\]{}()*+?.,\\\^$|#]/ig, "\\$&").toLowerCase();
		const queryLink = Immutable.fromJS({
						searchTerm: query,
						title: query,
						target: '//www.svt.se/search/?q=' + query,
						searchLink: true
		});
		
		if(!escapedQuery) {
			return Immutable.List();
		}

		return values.reduce((filtered, program) => {
							const weight = program.get('title','').toLowerCase().indexOf(escapedQuery);
							return (weight > -1)?filtered.push(program.set('weight', weight)):filtered;
						}, Immutable.List().asMutable())
						.asImmutable()
						.sort((a, b) => a.get('weight') - b.get('weight'))
						.slice(0, AUTO_COMPLETE_MAX_ITEMS)
						.push(queryLink);
	}
);

const autoCompleteSelector = createSelector(
	[
		autoCompleteActiveIndexSelector,
		autoCompleteQuerySelector,
		autoCompleteSuggestionsSelector
	],
	(selectedIndex, query, suggestions) => {
		const count			= suggestions.count() <= 1 ? 0 : suggestions.count() -1;
		const selected	= suggestions.get(selectedIndex, Immutable.Map());
		const result		=	Immutable.Map().withMutations((map) => {
												map.set('count', count);
												map.set('show', suggestions.count() !== 0);
												map.set('index', selectedIndex);
												map.set('selected', selected);
												map.set('searchTerm', query);
												map.set('suggestions', suggestions);
												return map;
											});

		return result;
	}
);

module.exports = autoCompleteSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/autoCompleteSelector.js
 **/